<template>
    <div>

        <v-list :disabled="isLoading">
            <v-list-item v-for="(url,label) in downloads"
                         :key="i"
                         :href="url"
                         target="_blank"
                         @click="onClick(url)">
                <v-list-item-icon>
                    <v-icon :color="isDownloaded(url) ? 'green':''">
                        {{ downloadIcon(url) }}
                    </v-icon>
                  </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ label }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>

        <v-divider class="mt-3"/>

        <div class="d-flex mt-5">
            <v-spacer/>
            <ActionProviderButtonComplete :action="action"
                                          label="Ho scaricato i file"
                                          @completed="onCompleted"
                                          :loading.sync="isLoading"/>
        </div>

    </div>
</template>

<script>
import actionProvider from '@/mixins/actionProvider'
import fileMixin from '@/mixins/file'

export default 
{
   name: 'ActionProviderFileDownload',

   mixins: [ actionProvider, fileMixin ],

   components: 
   {
   },

   data: () => ({
    downloaded: [],
    isLoading: false
   }),

   props: {
    
   },

   computed: 
   {
    downloads()
    {
        return this.action.componentMeta.downloads
    }
   },

   methods:
   {
    downloadIcon(url)
    {
        const defaultIcon = this.getIcon(url,"mdi-download")

        return this.isDownloaded(url) ? 'mdi-check-circle' : defaultIcon
    },

    isDownloaded(url)
    {
        return ( this.downloaded.indexOf(url) >= 0 )
    },

    onClick(url)
    {
        if( !this.isDownloaded(url) )
            this.downloaded.push(url)
    }
   },

   mounted()
   {

   }
}
</script>